import { render, staticRenderFns } from "./cursos-paginacion.vue?vue&type=template&id=61be88d1&scoped=true&"
import script from "./cursos-paginacion.vue?vue&type=script&lang=ts&"
export * from "./cursos-paginacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be88d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
